<template>
  <div>
    <div class="img" :style="`background-image:url('${img}')`"></div>
    <div class="body">
      <div class="txtcenter">
        <el-divider content-position="left">【{{ subject }}】 </el-divider>
        <p>{{ title }}</p>
      </div>
      <div>
        <div class="divide">项目介绍</div>
        <div class="divide2"></div>
        <div class="msg">
          <div class="line" v-for="item in msg" :key="item.title">
            <p>
              <b>{{ item.title }}</b>
              <span>{{ item.content }}</span>
            </p>
          </div>
        </div>
        <div>
          <div class="divide">涉及领域</div>
          <div class="divide2"></div>
          <div>
            <span>
              本课题涉及到<b> {{ involve }} </b>等方面的知识，适合申请
              <b> {{ direction }} </b>
              等相关专业的学生
            </span>
          </div>
        </div>
        <div>
          <div class="divide">适合人群</div>
          <div class="divide2"></div>
          <div class="msg">
            <div class="line" v-for="item in people" :key="item">
              <p>
                <span>{{ item }}</span>
              </p>
            </div>
          </div>
        </div>
        <div>
          <div class="divide">项目特点</div>
          <div class="divide2"></div>
          <div>
            <div v-for="item in results" :key="item.title">
              <p>
                <b>{{ item.title }}</b>
              </p>
              <p>
                <span>{{ item.content }}</span>
              </p>
              <p>&nbsp;</p>
            </div>
          </div>
        </div>
        <div>
          <div class="divide">研究前沿性</div>
          <div class="divide2"></div>
          <div>
            <div class="jiao1" />
            <div style="padding:0.213333rem 1em 0.213333rem">
              <div v-for="(content, index) in frontier" :key="`frontier-${index}`">
                <p style="text-align: justify;">
                  <span>
                    {{ content }}
                  </span>
                </p>
                <p>&nbsp;</p>
              </div>
            </div>
            <div class="jiao2" />
          </div>
        </div>
        <div>
          <div class="divide">研究介绍</div>
          <div class="divide2"></div>
          <div>
            <div class="jiao1" />
            <div style="padding:0.213333rem 1em 0.213333rem">
              <div v-for="(item, index) in introduce" :key="`introduce-${index}`">
                <p style="text-align: justify;">
                  <span>
                    {{ item }}
                  </span>
                </p>
                <p>&nbsp;</p>
              </div>
            </div>
            <div class="jiao2" />
          </div>
        </div>
        <div>
          <div class="divide">师资背景</div>
          <div class="divide2"></div>
          <div class="msg">
            <div class="line" v-for="item in teacher" :key="item">
              <p>
                <span>{{ item }}</span>
              </p>
            </div>
          </div>
        </div>
        <div>
          <div class="divide">课题要点</div>
          <div class="divide2"></div>
          <div>
            <p>
              <b>课题研究方法</b>
            </p>
            <p>
              <span>{{ points[0] }}</span>
            </p>
            <p>&nbsp;</p>
            <p>
              <b>课题难点</b>
            </p>
            <p>
              <span>{{ points[1] }}</span>
            </p>
            <p>&nbsp;</p>
          </div>
        </div>
        <div>
          <div class="divide">1v1定制化辅导参考任务</div>
          <div class="divide2"></div>
          <div class="task">
            <div class="tag">
              <p>
                <span>任务一</span>
              </p>
            </div>
            <div class="task-content">
              <p>
                <b>掌握查阅文献和研究方法</b>
              </p>
              <p
                v-for="s in [
                  '掌握查阅文献和面向文献学习的方法；',
                  '掌握文献管理的方法；',
                  '通过查阅文献，学习该方向的研究热点和方向；',
                  '掌握快速提炼文献重要信息的方法。'
                ]"
                :key="s"
                class="content"
              >
                <span>{{ s }}</span>
              </p>
            </div>
            <div v-for="(item, index) in task" :key="index">
              <div class="tag">
                <p>
                  <span>{{ taskt[index] }}</span>
                </p>
              </div>
              <div class="task-content">
                <p>
                  <b>{{ item[0] }}</b>
                </p>
                <p v-for="s in itemsplit(item)" :key="s" class="content">
                  <span>{{ s }}</span>
                </p>
              </div>
            </div>
            <div class="tag">
              <p>
                <span>任务六</span>
              </p>
            </div>
            <div class="task-content">
              <p>
                <b>项目收尾</b>
              </p>
              <p class="content">
                <span>
                  撰写整体报告；
                </span>
              </p>
              <p class="content">
                <span>
                  准备一次20~30分钟的presentation。
                </span>
              </p>
            </div>
          </div>
          <div class="tip">
            <p>
              <span> （以上任务仅供参考，实际辅导根据定制化要求展开）</span>
            </p>
          </div>
          <div>
            <div class="divide">科研补充包详情</div>
            <div class="divide2"></div>
            <div class="file">
              <div class="pdf" @click="download(0)">
                <img src="../assets/pdf文件.png" />
                <div>
                  <p>48课时科研基础课详情.pdf</p>
                  <span>150.11 KB</span>
                </div>
              </div>
              <div class="pdfdivide"></div>
              <div class="pdf" @click="download(1)">
                <img src="../assets/pdf文件.png" />
                <div>
                  <p>15课时学术写作基础课详情.pdf</p>
                  <span>140.07 KB</span>
                </div>
              </div>
              <div class="pdfdivide"></div>
              <div class="pdf" @click="download(2)">
                <img src="../assets/pdf文件.png" />
                <div>
                  <p>导师简历.pdf</p>
                  <span>120.05 KB</span>
                </div>
              </div>
              <div class="pdfdivide"></div>
              <div class="pdf" @click="download(3)">
                <img src="../assets/pdf文件.png" />
                <div>
                  <p>专属科研推荐信范例.pdf</p>
                  <span>135.22 KB</span>
                </div>
              </div>
            </div>
          </div>
          <div class="supply">
            <p>
              <span>
                (注:补充包所涉及课程，旨在为参与项目的学生强化学术基础，将与1v1正式科研穿插进行，当补充包课程与1v1核心专业指导时间冲突时，以1v1的指导安排为主。
              </span>
            </p>
            <p><span> 补充课程的具体安排安排及内容洋情参考附件。)</span></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '../axios'
export default {
  name: 'App',
  data () {
    return {
      msg: [
        { title: '正式科研：', content: '1v1线上定制辅导' },
        { title: '项目收获：', content: '科研报告（符合条件者可享国际普通期刊论文全文投递指导）、定制化推荐信网申10推' },
        {
          title: '科研补充包：',
          content: '48课时科研基础课+15课时学术写作基础课'
        }
      ],
      people: [
        '有意提高自身知识水平及学术能力的学生',
        '有意掌握最前沿科研热点及科研方法的学生',
        '有留学意向、跨专业深造的学生'
      ],
      results: [
        {
          title: '弥补"授课"模式教育背景下的能力缺失',
          content:
            '随着教育的发展，传统"授课"模式的弊端愈发凸显，而国外高校已经全面开展各种"任务式教学"、"探索性学习"、"翻转课堂"等教育模式以应对社会对于人才的多元化需求。在本项目中，学生可以通过真实的科研体验，提前适应全新的教育学习模式。'
        },
        {
          title: '在"试错"中大幅提高学术能力',
          content:
            '"试错"本身就是科研最重要的工作之一。在导师的引导下充分进行想象与尝试，学生在不断尝试及讨论中充分体验真实科研过程，并通过科研报告和学术演讲大幅提高学术表达能力。'
        },
        {
          title: '杜绝千篇一律的模板式推荐信',
          content:
            '导师通过"非授课"的教育模式对每个学生进行个性化指导，进而全面了解学生的科研状况，为学生出具真实的个人推荐信，最大限度提供升学助力。'
        }
      ],
      OSS: process.env.VUE_APP_OSS,
      img: '',
      subject: '',
      title: '',
      involve: '',
      direction: '',
      frontier: [],
      teacher: [],
      points: ['', ''],
      taskt: ['任务二', '任务三', '任务四', '任务五'],
      task: [],
      introduce: [],
      pdf: [],
      resume: ''
    }
  },
  mounted () {
    let x = document.body.clientWidth
    document.documentElement.style.fontSize = x / 16 + 'px'
    window.onresize = () => {
      return (() => {
        let x = document.body.clientWidth
        document.documentElement.style.fontSize = x / 16 + 'px'
      })()
    }
  },
  created () {
    let path = this.$route.fullPath
    let uuid = path.split('/').pop()
    axios
      .get('previews/get_repage', {
        params: {
          uuid: uuid
        }
      })
      .then(res => {
        let data = res.data
        this.frontier = data.frontier
        this.title = data.title
        this.img = data.img
        this.teacher = data.teacher
        this.teacher.splice(1, 0, 'EI/CPCI国际学术会议委员会成员')
        this.task = data.task
        this.introduce = data.introduce
        this.points = data.points
        this.involve = data.involve
        this.direction = data.direction
        this.subject = data.subject
        this.resume = data.resume
        document.title = this.title
        
        // 在数据加载完成后设置PDF数组
        this.pdf = [
          `${this.OSS}/pages/48课时科研基础课详情.pdf`,
          `${this.OSS}/pages/15课时学术写作基础课详情.pdf`,
          this.resume,
          `https://elitebackground.oss-cn-zhangjiakou.aliyuncs.com/poster/repage/%E4%B8%93%E5%B1%9E%E7%A7%91%E7%A0%94%E6%8E%A8%E8%8D%90%E4%BF%A1%E8%8C%83%E6%9C%AC.pdf`
        ]
      })
      .catch(() => {
        this.$router.push('/repage')
      })
  },
  methods: {
    itemsplit (item) {
      item = item.slice(1)
      item = item.map((e, index) => {
        if (index < item.length - 1) {
          e += '；'
        } else e += '。'
        return e
      })
      return item
    },
    download (index) {
      let routeData = this.$router.resolve({
        path: '/pdf',
        query: {
          url: this.pdf[index]
        }
      })
      window.open(routeData.href, '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
.img {
  width: 16rem;
  height: 16rem;
  background-size: cover;
  font-family: fantasy;
  margin-top: -2.5rem;
  .top {
    height: 16rem;
    position: relative;
    .h1 {
      position: absolute;
      bottom: 1rem;
      left: 2rem;
      width: 4.5rem;
      height: 0;
      border-bottom: 0.2rem solid #fff;
      font-family: fantasy;
    }
    .h2 {
      position: absolute;
      bottom: 2rem;
      left: 2rem;
      font-size: 1.5rem;
      color: #fff;
      font-family: fantasy;
      width: 4.5rem;
      line-height: 1.1;
    }
    .h3 {
      position: absolute;
      bottom: 1rem;
      right: 1rem;
      font-size: 0.4rem;
      color: #fff;
      line-height: 1.5;
      font-family: fantasy;
    }
    .h4 {
      position: absolute;
      bottom: 1rem;
      right: 1rem;
      font-size: 3rem;
      color: #fff;
      font-family: fantasy;
    }
  }
}
.body {
  padding: 0 0.68266667rem;
  text-align: left;
  font-size: 0.68266667rem;
  span {
    font-size: 0.597333rem;
    color: #2b2b2b;
  }
  p {
    font-size: 0.68266667rem;
    line-height: 1.6;
  }
}
.el-divider__text.is-left {
  left: 0;
}
.el-divider {
  background-color: #d6ae86;
  position: relative;
  &::before {
    content: '';
    width: 0.256rem;
    height: 0.256rem;
    border-radius: 100%;
    position: absolute;
    right: -0.128rem;
    top: -0.128rem;
    background-color: #dbb289;
  }
}
.el-divider--horizontal {
  margin: 1.4666667rem 0;
}
.el-divider__text {
  font-size: 0.768rem;
  color: #d6ae86;
  width: max-content;
}
.txtcenter {
  position: relative;
  padding: 0rem 0.426667rem 0.426667rem;
  p {
    text-align: left;
    font-size: 0.853rem;
    padding: 0.0853333rem 0.426667rem 0.0853333rem;
    color: rgb(0, 0, 0);
    font-weight: bolder;
    border-bottom: 0.128rem solid #d6ae86;
    display: inline-block;
    width: -webkit-fill-available;
  }
}
b {
  font-weight: bolder;
  color: #d6ae86;
  font-size: 0.597333rem;
}
span {
  font-size: 0.597333rem;
}
.divide {
  margin-top: 2.68266667rem;
  border-top: 1px solid rgb(219, 178, 137);
  border-bottom: 1px solid rgb(219, 178, 137);
  box-sizing: border-box;
  text-align: center;
  color: rgb(219, 178, 137);
  font-size: 0.768rem;
  font-weight: bold;
  letter-spacing: 2px;
  padding: 0.426667rem 0rem 0.426667rem;
  box-sizing: border-box;
}
.divide2 {
  margin: 0.426667rem auto 1.426667rem;
  height: 0rem;
  width: 0rem;
  border-width: 0.341333rem;
  border-style: solid;
  border-image: initial;
  border-color: rgb(219, 178, 137) transparent transparent;
  box-sizing: border-box;
}
.msg {
  padding-top: 0.68266667rem;
  .line {
    color: rgb(102, 102, 102);
    padding-left: 1.49333333rem;
    text-align: justify;
    p {
      display: list-item;
      &::marker {
        unicode-bidi: isolate;
        font-variant-numeric: tabular-nums;
        text-transform: none;
        text-indent: 0px !important;
        text-align: start !important;
        text-align-last: start !important;
      }
    }
  }
}
.task {
  border-left: 0.0853333rem solid rgb(214, 174, 134);
  .tag {
    display: inline-block;
    padding: 0.170667rem 0.170667rem 0.170667rem;
    margin-bottom: 0.341333rem;
    background-color: rgb(214, 174, 134);
    border-radius: 0rem 0.0853333rem 0.0853333rem 0rem;
    span {
      color: #fff;
      font-weight: bolder;
    }
  }
  .task-content {
    padding-left: 0.597333rem;
    padding-bottom: 1.024rem;
    .content {
      display: list-item;
      color: rgb(102, 102, 102);
      margin-left: 0.597333rem;
      text-align: justify;
      &::marker {
        unicode-bidi: isolate;
        font-variant-numeric: tabular-nums;
        text-transform: none;
        text-indent: 0px !important;
        text-align: start !important;
        text-align-last: start !important;
      }
    }
  }
}

.tip {
  font-style: italic;
}
.file {
  margin-top: 0.68266667rem;
  box-shadow: 0 0.08533333rem 0.34133333rem 0 rgba(0, 0, 0, 0.15);
  border-radius: 0.256rem;
  overflow: hidden;
  position: relative;
  display: inline-block;
}
.pdf {
  padding: 0.68266667rem;
  background-color: #fff;
  display: flex;
  cursor: pointer;
  div {
    flex: 1;
    padding-top: 0.256rem;
    margin-left: 0.68266667rem;
    p {
      font-size: 0.68266667rem;
      color: rgba(0, 0, 0, 0.87);
      line-height: 1.3;
      display: block;
      word-break: break-word;
    }
    span {
      font-size: 0.512rem;
      color: #9b9b9b;
      display: flex;
      margin-top: 0.34133333rem;
    }
  }
  img {
    width: 2.048rem;
    height: 2.56rem;
    background-size: 2.048rem 2.56rem;
    background-repeat: no-repeat;
  }
}
.pdfdivide {
  display: block;
  position: absolute;
  top: 50%;
  left: 0.68266667rem;
  right: 0.68266667rem;
  border-top: 0.04267rem solid rgba(120, 130, 140, 0.25);
  z-index: 100;
}
.supply {
  padding: 0.68266667rem 0;
  font-style: italic;
}
.jiao1 {
  width: 1.2em;
  height: 1.2em;
  border-top: 0.0853333rem solid rgb(219, 178, 137);
  border-left: 0.0853333rem solid rgb(219, 178, 137);
  margin-bottom: -0.256rem;
}
.jiao2 {
  width: 1.2em;
  height: 1.2em;
  border-bottom: 0.0853333rem solid rgb(219, 178, 137);
  border-right: 0.0853333rem solid rgb(219, 178, 137);
  margin-left: auto;
}
</style>
